module.exports = "<div ng-if=\"item()\">{{ item().getValue() }}</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/readonly-table/templates/default.html
// module id = 443
// module chunks = 0